import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { fetchVideoSeason } from "./store/action";
import Loading from "../components/Loading";
import { VideoSeasonProps } from "./store/actionType";
import { VideoGroupProps } from "../group/store/actionType";
import CreateSeason from "./page/CreateSeason";
import SeasonCard from "./page/component/SeasonCard";
import { VideoCategoryProps } from "../category/store/actionType";
import { VideoSeriesProps } from "../series/store/actionType";
import BreadcrumbFolderLayout from "../components/BreadcrumbFolderLayout";
import { AddFolderButton, SmallScreenModel } from "components";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../props/enum';

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const Season: React.FC<Props> = ({ videoSeasonsState, onFetchVideoSeason }) => {
  const navigate = useNavigate();
  const { groupId } = useParams<{ groupId: string }>();
  const groupsState = useSelector(
    (state: any) => state.videoGroups.videoGroupsState
  );
  const currentGroup = groupsState.groups?.filter(
    (group: VideoGroupProps) => group.id === groupId
  )[0];

  const { categoryId } = useParams<{ categoryId: string }>();
  const categoriesState = useSelector(
    (state: any) => state.videoCategories.videoCategoriesState
  );
  const currentCategory = categoriesState.categories?.filter(
    (category: VideoCategoryProps) => category.id === categoryId
  )[0];

  const { seriesId } = useParams<{ seriesId: string }>();
  const seriesState = useSelector(
    (state: any) => state.videoSeries.videoSeriesState
  );
  const currentSeries = seriesState.video_series?.filter(
    (series: VideoSeriesProps) => series.id === seriesId
  )[0];

  const [isModalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!isModalOpen);
  const closeModal = () => {
    setModalOpen(false);
  };
  const handleSectionClick = (id: string) => {
    navigate(`/video/${groupId}/${categoryId}/${seriesId}/${id}`);
  };
  const redirectToGroup = () => {
    navigate(`/video`);
  };
  const redirectToCategory = () => {
    navigate(`/video/${groupId}`);
  };
  const redirectToSeries = () => {
    navigate(`/video/${groupId}/${categoryId}`);
  };

  useEffect(() => {
    onFetchVideoSeason(seriesId ?? "");
  }, []);

  const breadcrumbItem = [
    {
      group: "Group",
      root: "Root",
      active: true,
      onClick: () => redirectToGroup(),
    },
    {
      group: currentGroup?.name,
      root: "Group",
      active: true,
      onClick: () => redirectToCategory(),
    },
    {
      group: currentCategory?.name,
      root: "Category",
      active: true,
      onClick: () => redirectToSeries(),
    },
    {
      group: currentSeries?.title,
      root: "Series",
    },
  ];
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_SEASON));
  return (
    <div className="h-full overflow-hidden">
      {videoSeasonsState && videoSeasonsState.isLoading && <Loading />}
      <BreadcrumbFolderLayout
        groupData={videoSeasonsState?.video_seasons}
        breadcrumbItem={breadcrumbItem}
        folders={
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {videoSeasonsState &&
                videoSeasonsState?.video_seasons &&
                videoSeasonsState?.video_seasons.map(
                  (seasonData: VideoSeasonProps) => (
                    <SeasonCard
                      key={seasonData.id}
                      seasonData={seasonData}
                      onClick={() => handleSectionClick(seasonData.id)}
                    />
                  )
                )}
            </div>
          </>
        }
        addFolderButton={
          <>
            {isPermitted && (
              <AddFolderButton onClick={toggleModal}>
                Create Season
              </AddFolderButton>
            )}
          </>
        }
      />
      <SmallScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
        <CreateSeason
          closeModal={closeModal}
          seriesFolderData={currentSeries}
        />
      </SmallScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  videoSeasonsState: state.videoSeasons.videoSeasonsState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchVideoSeason: (series_id: string) =>
    dispatch(fetchVideoSeason(series_id)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Season);
